import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-displayed-product',
  templateUrl: './displayed-product.component.html',
  styleUrls: ['./displayed-product.component.scss']
})
export class DisplayedProductComponent implements OnInit {

  @Input() productImg:string;
  @Input() productDescription:string;
  @Input() productTitle:string;
  @Input() productPrice:number;
  @Input() unavailableMsg:string;

  constructor() { }

  ngOnInit() { }

}
